import React from "react";
import { Link } from "react-router-dom";

export const Footer = () => {
    const actualYear = new Date().getFullYear();

    return (
        <footer className="footer py-3 navbar-dark bg-dark mt-auto">
            <div className="container">
                <ul className="nav justify-content-center border-bottom pb-3 mb-3">
                    <li className="nav-item">
                        <a target="_blank" className="nav-link px-2 footer-link" href="https://www.google.com/maps?ll=25.751371,-100.366433&z=17&t=m&hl=es-419&gl=MX&mapclient=embed&q=Oc%C3%A9ano+%C3%81rtico+8416+Loma+Linda+64120+Monterrey,+N.L.">
                            <i className="bi bi-pin-map-fill"></i> Maps
                        </a>
                    </li>
                    <li className="nav-item">
                        <a target="_blank" className="nav-link px-2 footer-link" href="https://www.facebook.com/profile.php?id=100093518463216">
                            <i className="bi bi-facebook"></i> Facebook
                        </a>
                    </li>
                    <li className="nav-item">
                        <a target="_blank" className="nav-link px-2 footer-link" href="https://www.instagram.com/academia.balam.boox">
                            <i className="bi bi-instagram"></i> Instagram
                        </a>
                    </li>
                    <li className="nav-item">
                        <a target="_blank" className="nav-link px-2 footer-link" href="https://wa.me/528135807416">
                            <i className="bi bi-whatsapp"></i> WhatsApp
                        </a>
                    </li>
                    <li className="nav-item">
                        <Link to="/gallery" className="nav-link px-2 footer-link">
                            <i className="bi bi-images"></i> Galería
                        </Link>
                    </li>
                </ul>
                <p className="text-center text-muted">&copy; 2023 - {actualYear} Maxter-Dev, derechos reservados.</p>
            </div>
        </footer>

    );
}